/**
 * Every format the platform writes in, by name.
 *
 * A field says which format it holds by naming one of these. An app that DRAWS
 * formatted text holds an adapter per name, so a format added here fails that
 * app's typecheck until something can show it. Editing makes no such promise:
 * a format says what its source editor offers, and one that is not written as
 * its source needs an editor of its own before a screen can offer it.
 */

import { board } from './board'
import { book } from './book'
import type { Format } from './format'
import { html } from './html'
import { markdown } from './markdown'
import { motif } from './motif'
import { slides } from './slides'

export const FORMATS = {
  board,
  book,
  html,
  markdown,
  motif,
  slides,
} as const satisfies Record<string, Format>

export type FormatId = keyof typeof FORMATS

/** Whether a stored name identifies a format this build understands. */
export function isFormatId(id: string): id is FormatId {
  return Object.hasOwn(FORMATS, id)
}

/** The definition a name stands for. */
export function formatOf(id: FormatId): Format {
  return FORMATS[id]
}
